import * as React from 'react';

import { createIcon } from '../Icon';
export const SquareIcon = createIcon(
  <rect height={18} rx={2} ry={2} width={18} x={3} y={3} />,
  'SquareIcon'
);
